import {
  TDiscountTableData,
  TDiscountTableDataCalculation,
  TServicesTableDataCalculation,
  TServiceTableData,
} from 'modules/accommodations/features/reservations/models';

export const transformServicesAndDiscountsForAPI = (
  calculationServices: TServiceTableData[],
  calculationDiscounts: TDiscountTableData[],
  numberOfGuestsSum: number,
  from: string,
  to: string,
) => {
  const services: TServicesTableDataCalculation[] = [...calculationServices].map(
    (item: TServiceTableData) => {
      return {
        serviceId: item.rootId,
        unitOfMeasureId: item.unitOfMeasureRootId! || item.unitOfMeasureId,
        numberOfGuests: numberOfGuestsSum,
        dateFrom: item.dateFrom,
        dateTo: item.dateTo,
        sellingPricePerUnitOfMeasure: item.sellingPricePerUnitOfMeasure,
        // amount: item.amount,
      };
    },
  );

  const discounts: TDiscountTableDataCalculation[] = [...calculationDiscounts].map(
    (item: TDiscountTableData) => {
      return {
        numberOfGuests: numberOfGuestsSum,
        dateFrom: from,
        dateTo: to,

        reservationDiscountType: item.reservationDiscountType,
        amountPerDiscountType: item.amountPerDiscountType,
        // serviceId: item.rootId,
        // applyDiscountPriceTo: item.applyDiscountPriceTo,
      };
    },
  );

  return { services, discounts };
};
